import { ShiftSeriesV2 } from '../shift-series-v2/shift-series-v2';
export interface ShiftSeriesRouterLink {
  routerLink: string | string[];
  name: string;
  queryParams?: Record<string, unknown>;
}

export type ShiftSeriesV2RouterLinkInput = Pick<
  ShiftSeriesV2,
  'validFrom' | 'name' | 'id'
>;

export const isShiftSeriesV2RouterLinkInput = (
  value: unknown,
): value is ShiftSeriesV2RouterLinkInput => {
  return (
    typeof value === 'object' &&
    value !== null &&
    'validFrom' in value &&
    'name' in value &&
    'id' in value
  );
};

export function generateShiftSeriesV2RouterLink(
  shiftSeriesV2: ShiftSeriesV2RouterLinkInput,
): ShiftSeriesRouterLink | undefined {
  return isShiftSeriesV2RouterLinkInput(shiftSeriesV2)
    ? {
        routerLink: ['/shift-series-v2'],
        queryParams: {
          pageSize: 50,
          date: shiftSeriesV2.validFrom,
          search: shiftSeriesV2.name,
          shiftSeriesV2ToEdit: shiftSeriesV2.id,
        },
        name: shiftSeriesV2.name,
      }
    : undefined;
}
